import React, {Fragment} from 'react';
import Overlay from 'Components/Overlay';
import Cx from 'classnames';

const ApproverConfirmationPopup = (props)=>(
    <Fragment>
        <Overlay>
            <div className="bg-white box-shadow ph-20 pv-20 br-5">
                <div className="mb-10 tCenter header-medium-color fSemibold fs-18">
                    {props.text}
                </div>
                {
                    (props.hasInput || props.hasRemarks) &&
                    <div className="mb-30 tCenter header-medium-color fSemibold fs-18">
                        <textarea name="Approver Loi Meassge"
                            placeholder={props.placeholder || "Meassge"}
                            onChange={(e) => props.onChange(e)}
                  value={props.value} className="pl-10 pt-10 fs-16 border-light ht-80 col-1 br-5"/>
                    </div>
                    
                }
                <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                    <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={props.onCancel}>Cancel</button>
                    <button className={Cx("ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30", {
                        'notselectable': !props.value
                    })} onClick={props.onConfirm}>{props.hasInput ? <Fragment>Send Message To User</Fragment> : <Fragment>Confirm</Fragment>}</button>
                </div>
            </div>    
        </Overlay> 
    </Fragment>
);

export default ApproverConfirmationPopup;